var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 570.41 506.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#dc0032;}.b{fill:#ffce00;}.c{fill-rule:evenodd;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A40-1 korkortonline.se") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M285.4.2a46.09,46.09,0,0,0-39.9,23L6.37,437.39a46.06,46.06,0,0,0,39.91,69.09H524.53a46.06,46.06,0,0,0,39.9-69.09L325.31,23.23A46.09,46.09,0,0,0,285.4.2Z",
    transform: "translate(-0.2 -0.2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M512.24,453.33,285.4,60.43,58.56,453.33Z",
    transform: "translate(-0.2 -0.2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M253.51,201.48a31.89,31.89,0,0,1,63.78,0V386.32a31.89,31.89,0,0,1-63.78,0Z",
    transform: "translate(-0.2 -0.2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningSign);
export default __webpack_public_path__ + "static/media/warning_sign.bb061f90a3b12344f749490c60715006.svg";
export { ForwardRef as ReactComponent };